import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { default as ReactSlick } from 'react-slick';

import type {
  SliderHandles,
  Props as SliderProps,
  State as SliderState
} from '@swf/components/Slider/Slider';
import Slider from '@swf/components/Slider/Slider';
import { select } from '@swf/core/store';

import styles from './RaceBody.scss';

interface Props {
  sliderRef?: React.RefObject<SliderHandles>;
  sliderState?: SliderState;
  onScroll?: SliderProps['onScroll'];
  racesElements: JSX.Element[];
}

const reactSlickSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  speed: 400,
  centerMode: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 930,
      settings: {
        centerMode: true,
        centerPadding: '0%',
        slidesToShow: 1,
        variableWidth: true
      }
    }
  ]
};

const itemsToShow = (racesElementsCount: number) =>
  [undefined, styles.oneRace, styles.twoRace][racesElementsCount] || styles.threeRace;

const RaceBody: React.FC<Props> = ({ racesElements, sliderRef, onScroll }) => {
  const isMobile = useSelector(select.device.isMobile);
  const racesElementsCount = racesElements.length;

  return isMobile && racesElementsCount > 1 ? (
    <div className={styles.crmCarousel}>
      <ReactSlick {...reactSlickSettings}>{racesElements}</ReactSlick>
    </div>
  ) : (
    <Slider
      onScroll={onScroll}
      ref={sliderRef}
      innerClassName={classNames(itemsToShow(racesElementsCount), isMobile && styles.mobile)}
    >
      {racesElements}
    </Slider>
  );
};

export default RaceBody;
